import gql from "graphql-tag";

export const OFFICE_QUERY_FOR_SPECS = gql`
  query OfficeSpecsQuery($projectId: SmartID!) {
    project(id: $projectId) {
      id
      creator {
        id
        office {
          id
          defaultSpecs
        }
      }
    }
  }
`;
